import * as React from "react";
import { formatDate } from "../../utils/date";

import { Box, Typography, Modal, Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "90vh",
  p: 4,
};
export default function SponsoredHistoryModal({ open, onClose, rowData }) {
  const rowsPerPage = 10;
  const [page, setPage] = React.useState(1);
  const safeRowData = Array.isArray(rowData) ? rowData : [];
  const totalRows = safeRowData.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const pageStart = (page - 1) * rowsPerPage;
  const pageEnd = Math.min(pageStart + rowsPerPage, totalRows);
  const pagedRows = safeRowData.slice(pageStart, pageEnd);

  React.useEffect(() => {
    setPage(1);
  }, [totalRows]);

  const handlePrevious = () => {
    setPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-lg">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Sponsored History {safeRowData[0]?.name}
          </Typography>
          <hr />
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <table>
              <thead>
                <tr>
                  <th>Mentor</th>
                  <th>Mentor email</th>
                  <th>Mobile</th>
                  <th>Kid Name</th>
                  <th>Amount</th>
                  <th>Mentored Date</th>
                </tr>
              </thead>
              <tbody>
                {pagedRows.map((d, index) => (
                  <tr key={index}>
                    <td>{d.full_name}</td>
                    <td>{d.email}</td>
                    <td>{d.mobile_no}</td>
                    <td>{d.name}</td>
                    <td>{d.amount}</td>
                    <td>{formatDate(d.mentored_on_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalRows > 0 ? (
              <div
                className="text-right"
                style={{
                  marginTop: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <button
                  type="button"
                  onClick={handlePrevious}
                  disabled={page <= 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "6px",
                    border: "1px solid #d0d7de",
                    background: "#fff",
                    cursor: page <= 1 ? "not-allowed" : "pointer",
                  }}
                >
                  Previous
                </button>
                <span style={{ color: "#555" }}>
                  Showing {pageStart + 1}-{pageEnd} of {totalRows}
                </span>
                <button
                  type="button"
                  onClick={handleNext}
                  disabled={page >= totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "6px",
                    border: "1px solid #d0d7de",
                    background: "#fff",
                    cursor: page >= totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  Next
                </button>
              </div>
            ) : null}
            <div className="text-right">
              <Button onClick={onClose} sx={{ mt: 1 }} variant="outlined">
                Cancel
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
